// src/push.js
import { initializeApp, getApps } from "firebase/app";
import { getMessaging, getToken, onMessage, isSupported } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyAvJCjt5tvePbQ6W-RR2jgUo274bPwMytY",
  authDomain: "comunica-72ae1.firebaseapp.com",
  projectId: "comunica-72ae1",
  storageBucket: "comunica-72ae1.appspot.com",
  messagingSenderId: "623837245023",
  appId: "1:623837245023:web:faadd4f3bca7bd20e875ea",
  measurementId: "G-50B0VK4VDK"
};

function initFirebaseOnce() {
  if (!getApps().length) initializeApp(firebaseConfig);
}

export async function ensurePushReady() {
  const supported = await isSupported().catch(() => false);
  if (!supported) return { ok:false, reason:"unsupported" };

  initFirebaseOnce();
  // registra il SW (non fare unregister)
  const registration = await navigator.serviceWorker.register("/firebase-messaging-sw.js");
  await navigator.serviceWorker.ready;
  return { ok:true, registration };
}

export async function getFcmToken(registration) {
  const messaging = getMessaging();
  const vapidKey = "BHvOOjrLM66lnBfZd1-PiL9XW7Y29PE4qoavHRgTBeEpvMiusywZB7BsoJMCw_Bi54KbTuaNXCUP7nS7jaIQAsk";
  return await getToken(messaging, { vapidKey, serviceWorkerRegistration: registration });
}

export function listenForeground(handler) {
  const messaging = getMessaging();
  onMessage(messaging, handler);
}
